import ethereum from 'decentralized/ethereum.js';
import accounts from 'accounts/Accounts.js';
import {web3} from 'decentralized/web3.js';
import {PRESET} from 'constants/content-types.js';
import Item from './Item.js';

class Preset extends Item {
    constructor(name, contentHash, user, blockNumber) {
        super();
        this.name = name;
        this.contentHash = contentHash;
        this.user = user;
        this.blockNumber = blockNumber;
        this.tags = [];
    }

    getJson() {
        return {
            name: this.name,
            contentHash: this.contentHash,
            user: this.user,
            blockNumber: this.blockNumber,
            hasEdits: this.hasEdits
        };
    }

    fromJson(json, load=true) {
        if (json.name || !load) {
            // this.name = json.name;
            if (json.contentHash) {
                this.contentHash = json.contentHash;
            }
            this.user = json.user;
            this.blockNumber = json.blockNumber;
            this.hasEdits = json.hasEdits;
            if (load) {
                this.load();
            }
        }
        return this;
    }

    async load() {
        if (this.contentHash) {
            this.tags = await ethereum.presets.getTags(this.contentHash);
        }
    }

    getContentType() {
        return PRESET;
    }

    get title() {
        return this.name;
    }

    get ipfsHash() {
        return this.contentHash;
    }

    getName() {
        return this.name;
    }

    getId() {
        return this.contentHash;
    }

    newTag(tag) {
        if (this.isCreated()) {
            this.tags.push(tag);
            ethereum.presets.tagPreset(this.contentHash, [tag], 0) ;
        }
    }

    async save(name) {
        let trackNumber = this.track.trackNumber;
        this.name = name;
        this.user = await accounts.getAccount();
        this.hasEdits = false;
        this.blockNumber = await web3.eth.getBlockNumber();

        this.contentHash = await this.track.sequencerEngine.saveTrackPreset(
            trackNumber,
            name,
            false,
            0,
            this.contentHash
        );
    }
}

export default Preset;
